export const BULK_CONTRIBUTOR_ROLE = 'bulk_contributor';
const FASTCUBE_ORG_NAME = 'FastCube';

/** Drop Bulk Contributor from catalogs for organizations other than FastCube. */
export function catalogForOrganization(catalog, orgName) {
  if (!catalog || orgName === FASTCUBE_ORG_NAME) return catalog;
  return {
    ...catalog,
    roles: (catalog.roles || []).filter((role) => role.key !== BULK_CONTRIBUTOR_ROLE),
  };
}
